module.exports = __webpack_public_path__ + "035aad10163d4723b7f62d21a2ec70b4.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/angry-29.png
// module id = 2055
// module chunks = 0